import { hasActiveModuleGrant } from '@realadvisor/constants';
import { Navigate, Outlet, type To } from 'react-router-dom';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export const ModuleRoute: React.FC<{
  module: string;
  redirectTo?: To;
}> = ({ module, redirectTo }) => {
  const { me } = useAppData();

  return hasActiveModuleGrant(me?.module_grants, module) ? (
    <Outlet />
  ) : (
    <Navigate to={redirectTo ?? '/dashboard'} replace />
  );
};
